// The destination picked on Home (or anywhere that opens the planner) is kept for
// the tab, so the planner chooser, the AI planner and a reload all show the same city.
const KEY = 'gb.planner.destination';

export function saveSelectedDestination(dest) {
  try {
    if (!dest || (typeof dest !== 'string' && !dest.name)) sessionStorage.removeItem(KEY);
    else sessionStorage.setItem(KEY, JSON.stringify(dest));
  } catch { /* storage unavailable — the selection just isn't remembered */ }
}

export function loadSelectedDestination() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const dest = JSON.parse(raw);
    return typeof dest === 'string' ? (dest.trim() || null) : (dest && dest.name ? dest : null);
  } catch {
    return null;
  }
}

export const destinationName = (dest) => (typeof dest === 'string' ? dest : dest?.name || '');

const cityIdOf = (dest) => {
  if (Number.isInteger(dest.cityId) && dest.cityId > 0) return dest.cityId;
  const m = /^gb:city:(\d+)$/.exec(String(dest.id ?? ''));
  return m ? Number(m[1]) : null;
};

// Manual planner prefill: a resolved city is added directly; anything else seeds its search.
export function manualPrefillFor(dest) {
  if (!dest) return null;
  if (typeof dest === 'string') return { prefillQuery: dest };
  const cityId = cityIdOf(dest);
  const hasCoords = Number.isFinite(dest.lat) && Number.isFinite(dest.lng);
  if (cityId == null && !dest.placeId && !hasCoords) return { prefillQuery: dest.name };
  return {
    name: dest.name,
    cityId: cityId ?? undefined,
    placeId: dest.placeId,
    lat: hasCoords ? dest.lat : undefined,
    lng: hasCoords ? dest.lng : undefined,
  };
}
